import type { CityConfig } from "../city-template/types";

export const hendersonvilleConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Hendersonville",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "hendersonville",
  route: "/hendersonville",
  title: "Emergency Passport Hendersonville, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Hendersonville, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Henderson County and the Blue Ridge Mountain region. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Hendersonville, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Hendersonville and Blue Ridge Mountain travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Hendersonville%20North%20Carolina%20scenic%20mountain%20town%20at%20golden%20hour%20with%20historic%20downtown%20main%20street%2C%20charming%20brick%20storefronts%20and%20tree-lined%20sidewalks%2C%20Blue%20Ridge%20Mountains%20visible%20in%20the%20background%20with%20rolling%20green%20hills%2C%20warm%20sunset%20light%20over%20Henderson%20County%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20landscape%20photography%20with%20warm%20earthy%20tones%20and%20mountain%20town%20atmosphere%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=hendersonville-hero-nc-001&orientation=landscape",
  heroImageAlt: "Hendersonville North Carolina historic downtown with Blue Ridge Mountains in the background at golden hour",
  geoPosition: "35.3187;-82.4610",
  geoPlacename: "Hendersonville, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 190 miles from Hendersonville via I-26",
  },
  nearbyCitiesZips: [
    { name: "Hendersonville", zips: "28739, 28791, 28792" },
    { name: "Asheville", zips: "28801–28816" },
    { name: "Flat Rock", zips: "28731" },
    { name: "Fletcher", zips: "28732" },
    { name: "Brevard", zips: "28712" },
    { name: "Black Mountain", zips: "28711" },
    { name: "Waynesville", zips: "28785, 28786" },
    { name: "Mills River", zips: "28759" },
    { name: "Arden", zips: "28704" },
    { name: "Candler", zips: "28715" },
    { name: "Weaverville", zips: "28787" },
    { name: "Canton", zips: "28716" },
    { name: "Swannanoa", zips: "28778" },
    { name: "Etowah", zips: "28729" },
    { name: "Horse Shoe", zips: "28742" },
    { name: "Zirconia", zips: "28790" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Henderson County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Blue Ridge Mountain Coverage", desc: "Serving Hendersonville, Asheville, and the western North Carolina mountain region" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Asheville, NC", route: "/asheville" },
    { name: "Fast passport renewal in Charlotte, NC", route: "/charlotte" },
    { name: "Emergency passport help in Greensboro, NC", route: "/greensboro" },
    { name: "Urgent passport services in Winston-Salem, NC", route: "/winston-salem" },
    { name: "Same-day passport help in Raleigh, NC", route: "/raleigh" },
    { name: "Passport courier services in Durham, NC", route: "/durham" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Hendersonville remotely via secure courier. We do not have a walk-in office in Hendersonville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Henderson County and the Blue Ridge Mountain region travelers.",
  fpcOfficeAddress: "301 S McDowell St, Charlotte, North Carolina 28204",
  fpcOfficeDistance: "Serving all of Henderson County and the Blue Ridge Mountain region including Buncombe and Haywood counties",
  serviceAreaIntro: "From the historic downtown streets of Hendersonville to the mountain communities of Flat Rock and Fletcher, from the scenic roads of Brevard and Black Mountain to the bustling corridors of Asheville — Fast Passport Center serves the entire Hendersonville region. We regularly help travelers from Mills River, Arden, Candler, and Waynesville get their passports fast.",
  nearbyCitiesIntro: "We serve all Hendersonville neighborhoods and the surrounding Blue Ridge Mountain area including Asheville, Flat Rock, Fletcher, Brevard, Black Mountain, Waynesville, Mills River, Arden, Candler, Weaverville, Canton, Swannanoa, Etowah, Horse Shoe, and Zirconia. If you are anywhere in Henderson, Buncombe, or Transylvania counties, we have you covered.",
  howItWorksIntro: "Most Hendersonville travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Hendersonville travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Hendersonville and Blue Ridge Mountain travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Hendersonville? Here are the most common ones we hear from Henderson County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Hendersonville international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Karen L.",
      location: "Hendersonville, NC",
      rating: 5,
      text: "My passport expired the week before our trip to Ireland. Fast Passport Center had my renewal in 4 days. Never had to leave the mountains. Outstanding service.",
      service: "Passport Renewal",
    },
    {
      name: "Mark D.",
      location: "Flat Rock, NC",
      rating: 5,
      text: "Emergency passport for a family medical emergency in London. Got it in 30 hours. The team was incredibly responsive and compassionate. True lifesavers.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer R.",
      location: "Fletcher, NC",
      rating: 5,
      text: "Business trip to London came up with 7 days notice. They got me a passport in 4 business days. The communication was outstanding throughout the process.",
      service: "Emergency Passport",
    },
    {
      name: "Tom S.",
      location: "Brevard, NC",
      rating: 5,
      text: "First passport for my daughter before her mission trip to Peru. Fast Passport Center helped us navigate every step. Ready in 5 days with zero stress.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "hendersonville-1",
      name: "Hendersonville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "825 Spartanburg Hwy",
      city: "Hendersonville",
      state: "NC",
      zip: "28792",
      phone: "(828) 692-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Hendersonville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Hendersonville facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "hendersonville-2",
      name: "Asheville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "445 Postal Rd",
      city: "Asheville",
      state: "NC",
      zip: "28803",
      phone: "(828) 274-4535",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles north of Hendersonville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Buncombe County. Full passport services. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "hendersonville-3",
      name: "Brevard Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "160 S Broad St",
      city: "Brevard",
      state: "NC",
      zip: "28712",
      phone: "(828) 883-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles west of Hendersonville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Transylvania County and western Henderson County. Less crowded.",
      icon: "ri-mail-line",
    },
    {
      id: "hendersonville-4",
      name: "Flat Rock Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2700 Greenville Hwy",
      city: "Flat Rock",
      state: "NC",
      zip: "28731",
      phone: "(828) 693-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles south of Hendersonville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Flat Rock and southern Henderson County. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "hendersonville-5",
      name: "Henderson County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "200 N Grove St",
      city: "Hendersonville",
      state: "NC",
      zip: "28792",
      phone: "(828) 694-4100",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Henderson County Courthouse, downtown",
      website: "https://www.hendersoncountync.gov/",
      websiteLabel: "Henderson County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "hendersonville-6",
      name: "Fletcher Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "50 Fanning Bridge Rd",
      city: "Fletcher",
      state: "NC",
      zip: "28732",
      phone: "(828) 684-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles north of Hendersonville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fletcher and northern Henderson County. Full passport services.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3.5 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Hendersonville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Henderson County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Hendersonville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Henderson County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Hendersonville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Hendersonville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Hendersonville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Hendersonville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Hendersonville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 3.5 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Hendersonville?", a: "Fast Passport Center offers fast passport renewal in Hendersonville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Hendersonville?", a: "The nearest regional passport agency to Hendersonville is the Atlanta Passport Agency, approximately 190 miles away via I-26. For urgent processing without the mountain drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Hendersonville without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Hendersonville?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 3.5 hours from Hendersonville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Henderson County residents." },
    { q: "Do you serve the entire Blue Ridge Mountain region?", a: "Absolutely. Fast Passport Center serves the entire Blue Ridge Mountain region including Hendersonville, Asheville, Flat Rock, Fletcher, Brevard, Black Mountain, Waynesville, Mills River, Arden, Candler, Weaverville, Canton, Swannanoa, Etowah, Horse Shoe, and Zirconia. Our courier service works seamlessly from any address in Henderson, Buncombe, or Transylvania counties." },
    { q: "Can I expedite a child passport in Hendersonville?", a: "Yes. Fast Passport Center expedites child passports in Hendersonville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Henderson County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Hendersonville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Hendersonville", address: "825 Spartanburg Hwy, Hendersonville, NC 28792", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Hendersonville", address: "644 5th Ave W, Hendersonville, NC 28739", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Hendersonville", address: "250 Highlands Square Dr, Hendersonville, NC 28792", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Asheville", address: "91 Tunnel Rd, Asheville, NC 28805", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Brevard", address: "157 S Broad St, Brevard, NC 28712", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Fletcher", address: "50 Fanning Bridge Rd, Fletcher, NC 28732", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Black Mountain", address: "700 State St, Black Mountain, NC 28711", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart — Waynesville", address: "135 Town Center Loop, Waynesville, NC 28786", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Hendersonville",
      address: "1800 Four Seasons Blvd, Hendersonville, NC 28792",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Asheville",
      address: "1624 Hendersonville Rd, Asheville, NC 28803",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Brevard",
      address: "45 E Morgan St, Brevard, NC 28712",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Transylvania County. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Waynesville",
      address: "1853 Veterans Blvd, Waynesville, NC 28786",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Haywood County and west Buncombe County. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "AVL",
      name: "Asheville Regional Airport",
      distance: "15 miles north of Hendersonville",
      address: "61 Terminal Dr, Fletcher, NC 28732",
      note: "Primary airport for the Blue Ridge Mountain region. Direct flights to major domestic hubs including Atlanta, Charlotte, and Chicago. Seasonal international connections. Only 20 minutes from Hendersonville.",
      flightUrl: "https://flyavl.com/",
      flightLabel: "AVL Airport",
      featured: true,
    },
    {
      code: "GSP",
      name: "Greenville-Spartanburg International Airport",
      distance: "45 miles south of Hendersonville",
      address: "2000 GSP Dr, Greer, SC 29651",
      note: "Alternative airport for South Carolina and southern Henderson County travelers. Additional domestic routes.",
      flightUrl: "https://www.gspairport.com/",
      flightLabel: "GSP Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "100 miles east of Hendersonville",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub. American Airlines hub with direct flights to Europe, Mexico, and the Caribbean. Consider for international travel from the Blue Ridge Mountain region.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Henderson County Register of Deeds',
      description: 'Marriage licenses and records for Henderson County. Apply in person or request certified copies.',
      url: 'https://www.hendersoncountync.gov/rod',
    },
    {
      label: 'Henderson County Clerk of Superior Court',
      description: 'Divorce records and decrees for Henderson County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/henderson-county/henderson-county-clerk-of-superior-court',
    },
  ],
};